import SignInSectionTitle from "./SignInSectionTitle";
import SignInString from "./../../../images/SignInStrings.png";

type Props = {};

const SignInLeftSide = (props: Props) => {
  return (
    <div className="w-full h-full flex justify-center items-center relative xl:col-span-2 md:col-span-1">
      <img
        className=" absolute w-1/3  top-center left-center"
        src={SignInString}
      />
      <SignInSectionTitle title="Bet Gulf" subtitle="Dashboard" />
    </div>
  );
};

export default SignInLeftSide;
